import { Container, Row, Col, Navbar, Nav } from 'react-bootstrap';
import { useNavigate, Link } from "react-router-dom";
import { useContext } from "react";
import { ClienteContext } from "../../services/ClienteContext";
import "./styles.css";
import NotificationsAlert from '../../services/NotificationsAlert';
import Logo from '../../assets/Logo 300x300N.png'

const Header = () => {

  const cliente = useContext(ClienteContext);
  const history = useNavigate();
  const idUser = localStorage.getItem('id')
  const nameUser = localStorage.getItem('firstName')
  const lastNameUser = localStorage.getItem('lastName')

  const loginLogout = () => {
    const savedLogin = localStorage.getItem('savedLogin')
    const savedPassword = localStorage.getItem('savedPassword')

    cliente.setDados({ id: null, nome: "", token: "" });

    localStorage.clear()
    localStorage.setItem("savedLogin", savedLogin);
    localStorage.setItem("savedPassword", savedPassword);
    history("/login")
    let message = "Até breve!"
    NotificationsAlert("default", message, "")
  }

  let user;
  if (cliente.dados.user_id || idUser) {
    user = (
      <>
        <text className="btn" style={{ color: '#fff' }}>Olá {`${nameUser} ${lastNameUser}`} <i className="fas fa-sign-out-alt" /></text>
      </>
    )
  } else {
    user = (
      <>
        <text className="btn" style={{ color: '#fff' }}>Entrar <i className="fas fa-sign-in-alt"></i></text>
      </>
    )
  }

  return (
    <Navbar expand="lg" id='nav' className="navbar-dark">
      <Container>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Row className="justify-content-around align-items-center w-100" style={{ marginTop: "-1.5%", marginBottom: "-1.5%" }}>
            <Col xs="auto" id='home'>
              <Link className="navbar-brand" to="/home">
                <img src={Logo} style={{ width: "80px", marginRight: "2%" }} alt="Sakamotto Server Logo" />
                <text style={{ color: '#fff' }}>Library files by SakamottoSann</text>
              </Link>
            </Col>
            <Col xs="auto" className="text-center mt-2 mt-md-0">
              <Nav className="me-auto">
                {/* <Nav.Link><Link to="/home1" style={{ color: '#fff' }}>Home Teste</Link></Nav.Link>
                <NavDropdown style={{ color: '#fff' }} title={<text style={{ color: '#fff' }}>Relatórios</text>} id="basic-nav-dropdown" >
                  <div style={{ backgroundColor: '#5f74fd', marginTop: -10, marginBottom: -10 }}>
                     <NavDropdown.Item style={{ backgroundColor: '#5f74fd' }}>
                      <Link to="/workpoint" style={{ color: '#fff' }}>Pontos</Link>
                    </NavDropdown.Item>
                    <NavDropdown.Item style={{ backgroundColor: '#5f74fd' }}>
                      <Link to="/positions" style={{ color: '#fff' }}>Posições</Link>
                    </NavDropdown.Item>
                  </div>
                </NavDropdown> */}
              </Nav>
            </Col>
            <Col xs="auto" className="text-end">
              <Link
                onClick={loginLogout} style={{ color: '#fff' }}>
                {user}
              </Link>
            </Col>
          </Row>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};



export default Header;